import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';


const styles = theme => ({
  canvas: {
    width: '100%',
    height: '100%'
  }
});

const phrases = [
  ['沒錢', '說什麼大道理'],
  ['夢想就是你家', '但沒熱水給你洗澡'],
  ['PMB請大家', '預排至下周五!'],
  ['不行不行', '全都不行'],
  ['薩爾達總算打死人馬', '大家都玩別的了'],
  ['你沒說清楚', '現在改來不及了'],
];


class CropCanvas extends Component {
  constructor(props) {
    super(props);
    // size
    this.state = {
    };
    this.canvas = null;
    this.ctx = null;
    this.maxLength = this.props.resizeLength;
    this.texts = phrases[Math.floor((Math.random() * (phrases.length - 1)))];
    this.fontSize = 25;
  }

  componentDidMount() {
    this.setCanvas();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.size.width !== this.props.size.width || prevProps.size.height !== this.props.size.height){
      this.setCanvas();
    }
  }

  initCanvas = elm => {
    if (!elm) return;
    this.canvas = elm;
    this.ctx = elm.getContext('2d');
  }

  setCanvas = () => {
    var validate = {
      size: true,
      aspect: true,
    };

    const size = this.props.size;
    
    const cropMaxLength = Math.max(size.width, size.height);
    const ratio = this.maxLength / cropMaxLength;
    this.canvas.width = size.width * ratio;
    this.canvas.height = size.height * ratio;
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

    if (Math.min(size.width, size.height) < 100){
      validate.size = false;
    }

    const aspect = size.width/size.height;
    if (aspect <= 2.0/3.0 || aspect >= 3.0/2.0){
      validate.aspect = false;
    }

    if (validate.size && validate.aspect){
      this.drawText();
    }
    
    this.props.setValidate(validate);
  }

  drawText = () => {
    this.ctx.textAlign = 'center'; 
    for (var i = 0; i < 2; i++) {
      const w = this.canvas.width/2;
      const h = i === 0 ? 25 : this.canvas.height - 8;
      const text = this.texts[i];

      var currentFontSize = this.fontSize;
      this.ctx.font = currentFontSize + 'px noto';
      while (this.ctx.measureText(text).width >= this.canvas.width){
        currentFontSize -= 1;
        this.ctx.font = (currentFontSize - 1) + 'px noto';
      }

      this.ctx.fillStyle = 'black';
      this.ctx.fillText(text, w-1, h-1);
      this.ctx.fillText(text, w+1, h-1);
      this.ctx.fillText(text, w-1, h+1);
      this.ctx.fillText(text, w+1, h+1);
      this.ctx.fillStyle = 'white';
      this.ctx.fillText(text, w, h);
    }
  }

  render() {
    const {classes} = this.props;
    return (
      <canvas className={classes.canvas} ref={this.initCanvas} />
    );
  }
}

export default withStyles(styles)(CropCanvas);


// WEBPACK FOOTER //
// ./src/components/CropCanvas.js